import React from 'react'

/**
 * @param value: Any
 * @param onChange: function(Any)
 * @param label: String?
 * @param disabled: Boolean? = false
 * @param hasErrors: Boolean? = false 
 * @param type: InputType? = InputTypes.TEXT
 * @param placeholder: String?
 * @param inputStyle: Object? : Style for the <input/> element
 */
class Input extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = this.validateInput(props.value)
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.value !== this.props.value)
        {
            this.setState({ value: this.props.value })
        }
    }

    isEmptyInputValid()
    {
        return (this.getInputType() === InputType.TEXT) || !!this.props.placeholder
    }

    getInputType()
    {
        return this.props.type || InputType.TEXT
    }

    validateInput(value)
    {
        const inputType = this.getInputType()
        value = String(value == null ? "" : value)

        if ((value === "" || value == null) && this.isEmptyInputValid()) {
            return {
                valid: true,
                value: null
            }
        }

        if (InputType.NUMBER === inputType)
        {
            let formattedValue = value.replace(/[^-0-9,\.]/g, "")
            let number = Number(formattedValue || "NaN")
            const valid = !isNaN(number) && !(formattedValue || "").match(/[\.,]$/)
            return {
                value: valid ? number : value,
                valid: valid
            }
        }
        else if (InputType.WHOLE_NUMBER === inputType)
        {
            let number = Number(value.replace(/[^-0-9]/g, "") || "NaN")
            return {
                value: isNaN(number) ? value : number,
                valid: !isNaN(number)
            }
        }

        return { value: value, valid: true }
    }

    handleChangeValue(newValue)
    {
        const validated = this.validateInput(newValue)
        if (validated.valid) {
            this.setState(validated, () => this.props.onChange(validated.value))
        } else {
            this.setState(validated)
        }
    }

    render()
    {
        const className = "dk-input "
            + ((this.state.valid && !this.props.hasErrors) ? "" : "invalid ")
            + (this.props.disabled ? "disabled " : "")
            + (this.props.className || "")

        const label = this.props.label ? (
            <div className="dk-label">{ this.props.label }</div>
        ) : null;

        return (
            <div style={ this.props.style } className={ className }>
                { label }
                <input
                    style={ this.props.inputStyle }
                    placeholder={ this.props.placeholder }
                    value={ this.state.value == null ? "" : this.state.value }
                    onChange={ e => this.handleChangeValue(e.target.value) }
                    onBlur={ () => this.setState(this.validateInput(this.props.value)) }
                />
            </div>
        )
    }

}

export const InputType = {
    TEXT: "text",
    NUMBER: "number",
    WHOLE_NUMBER: "whole-number"
}

export default Input
export { Input }